export{ALIGNMENT,CONTAINER_TAGS,FONT_FAMILY,FONT_WEIGHT,HEAD_LINES_TAGS,TEXT_DECORATION,TEXT_TAGS,TEXT_TRANSFORM}from"./ConTextAtom.types.js";export{ConTextAtom}from"./ConTextAtom.js";
